import { t } from '../../strings/i18n';
import { required } from '../../xform';
export const PAYMENT_METHOD_INPUT_NAME = 'paymentMethod';
const paymentMethodConfig = () => {
    return [
        PAYMENT_METHOD_INPUT_NAME,
        undefined,
        'ENABLED',
        [required(t('errors.paymentMethod'))]
    ];
};
export default paymentMethodConfig;
